import getHeaders from '../../helpers/headers'
import axios from 'axios'
import config from '../../../constants/endpoints.js'

const {
  endpoints: {
    plugins: {
      locators: { sendLocator: url },
    },
  },
} = config

/**
 * Send locator message to the user.
 *
 * @param {User} data.user User object
 * @param {Array} data.airlines Airlines names
 * @param {Array} data.locators Locators strings
 * @param {Array} data.type Type of locator (product)
 */
const sendLocator = (data) => axios.post(url, data, { headers: getHeaders(true) })

export default {
  sendLocator,
}
